import * as tslib_1 from "tslib";
import Vue from "vue";
// import VueAMap from 'vue-amap';
let vueAMap;
export class DefaultLocationService {
    initMap() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (vueAMap) {
                return vueAMap;
            }
            vueAMap = yield import(/* webpackChunkName: "vue-amap" */ "vue-amap");
            if (window._AMapSecurityConfig) {
                window._AMapSecurityConfig = {
                    securityJsCode: window._AMapSecurityConfig.securityJsCode
                };
            }
            ;
            Vue.use(vueAMap.default);
            vueAMap.initAMapApiLoader({
                key: "78f23ec25bc7f7f7d5e7bad042f56a88",
                plugin: [
                    "Geocoder",
                    "AMap.Geolocation",
                    "AMap.Autocomplete",
                    "AMap.PlaceSearch",
                    "AMap.Scale",
                    "AMap.OverView",
                    "AMap.ToolBar",
                    "AMap.MapType",
                    "AMap.PolyEditor",
                    "AMap.CircleEditor",
                    "AMap.Map"
                ],
                // 默认高德 sdk 版本为 1.4.4
                v: "1.4.14",
                uiVersion: "1.0.11"
            });
            return vueAMap;
        });
    }
    position(range, showMap) {
        return Promise.resolve({});
    }
    navigation(latitude, longitude, title) { }
    isEl() {
        return false;
    }
}
